import auth from "@/middleware/auth";
import fetchUserData from "@/middleware/fetchUserData";
import isSmsVerified from "@/middleware/isSmsVerified";
import persistWebview from "@/middleware/persistWebview";

const mainPageBreadCrumb = [{ name: "layouts.main_page", link: "Home" }];

export default {
  path: "/settings",
  meta: {
    smsVerified: 1,
    breadcrumb: [...mainPageBreadCrumb, { name: "layouts.account" }],
    middlewares: [fetchUserData, auth, isSmsVerified, persistWebview],
  },
  component: () =>
    import(/* webpackChunkName: "account" */ "@/layouts/UserSettings.vue"),
  children: [
    {
      path: "",
      name: "Settings",
      component: () =>
        import(
          /* webpackChunkName: "account" */ "@/views/User/Account/Personal.vue"
        ),
    },
    {
      path: "health-questionnaire",
      name: "HealthQuestionnaire",
      component: () =>
        import(
          /* webpackChunkName: "account-health-questionnaire" */ "@/views/User/Account/HealthQuestionnaire.vue"
        ),
    },
    {
      path: "requests-for-access",
      name: "RequestsForAccess",
      component: () =>
        import(
          /* webpackChunkName: "requests-for-access" */ "@/views/User/Account/RequestsForAccess.vue"
        ),
    },
    {
      path: "preferred-locations",
      name: "Account.PreferredLocations",
      component: () =>
        import(
          /* webpackChunkName: "account" */ "@/views/User/Account/PreferredLocations.vue"
        ),
    },
    {
      path: "invoice-data",
      name: "Account.InvoiceData",
      component: () =>
        import(
          /* webpackChunkName: "account" */ "@/views/User/Account/InvoiceData.vue"
        ),
    },
  ],
};
